import React, { FC, useMemo } from 'react';
import { ApprovalModalPartOfFdaProps } from './ApprovalModalPartOfFdaProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import RadioButtonGroup from '@ingka/radio-button-group';
import { returnRadioButtons } from './utils';
import checkmark from '@ingka/ssr-icon/paths/checkmark-circle';
import SSRIcon from '@ingka/ssr-icon';
import { getFormattedDate } from '../ProjectListTable/utils';
import skapaColours from '@ingka/variables/colours-css';

const ApprovalModalPartOfFda: FC<ApprovalModalPartOfFdaProps> = ({
  project,
  partOfFda,
  setPartOfFda,
}) => {
  const t = useTranslation();
  const list = useMemo(
    () => returnRadioButtons(t, partOfFda, setPartOfFda),
    [partOfFda],
  );
  return (
    <Stack>
      <RadioButtonGroup
        name={
          <>
            <Text>{t('ppm.columns.partOfFda')}</Text>
            <Text>
              <span style={{ fontWeight: 'normal' }}>
                {t('ppm.partOfFda.description')}
              </span>
            </Text>
          </>
        }
        list={list}
      />
      {project?.partOfFdaDate && (
        <Stack
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          pt={3}
          gap={2}
        >
          <SSRIcon
            style={{ color: skapaColours.colourSemanticPositive }}
            paths={checkmark}
          />
          <Text>
            {t('ppm.partOfFda.approved')}{' '}
            {getFormattedDate(new Date(project.partOfFdaDate))}
          </Text>
        </Stack>
      )}
    </Stack>
  );
};

export default ApprovalModalPartOfFda;
